// eslint-disable-next-line no-shadow
export enum HomeTabs {
	PROMPTS = 'prompts',
	MODELS = 'models',
}
